var $ = require('jquery');
window.jQuery = $;
window.$ = $;

import * as bootstrap from 'bootstrap';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPlugin from "gsap/ScrollToPlugin";
import SplitText from 'gsap/SplitText';
import ScrollSmoother from 'gsap/ScrollSmoother';
import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
import ScrambleTextPlugin from 'gsap/ScrambleTextPlugin';
import { createPopper } from '@popperjs/core';
import MorphSVGPlugin from "gsap/MorphSVGPlugin.js";
import { Mousewheel } from 'swiper/modules';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, SplitText, ScrollSmoother, DrawSVGPlugin, ScrambleTextPlugin, MorphSVGPlugin, Mousewheel);
gsap.registerEffect({
    name: "counter",
    extendTimeline: true,
    defaults: {
        end: 0,
        duration: 0.5,
        ease: "power1",
        increment: 1,
    },
    effect: (targets, config) => {
        let tl = gsap.timeline()
        let num = targets[0].innerText.replace(/\,/g, '')
        targets[0].innerText = num

        tl.to(targets, {
            duration: config.duration,
            innerText: config.end,
            //snap:{innerText:config.increment},
            modifiers: {
                innerText: function (innerText) {
                    return gsap.utils.snap(config.increment, innerText).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
            },
            ease: config.ease
        }, 0)

        return tl
    }
});
ScrollTrigger.config({
    duration: 0.3,
});


import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs, Controller, Autoplay, EffectCoverflow, EffectCards, EffectCreative } from 'swiper/modules';

function isSmall() {
    return (window.innerWidth < 640 && window.innerHeight > window.innerWidth);
}
function isMobile() {
    return mobileSniff();// /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(window.navigator.userAgent);
}
function iPhoneSniff() {
    return /iP(ad|hone|od).*OS/.test(window.navigator.userAgent);
}
function androidSniff() {
    return /Android/.test(window.navigator.userAgent);
}
function mobileSniff() {
    return iPhoneSniff() || androidSniff();
}

let smoother;

window.addEventListener('load', e => {

    ScrollTrigger.create({
        trigger: "body",
        start: "top+=300 top",
        end: 30000,
        toggleClass: {
            targets: [".navbar"],
            className: "scrolled",
        }
    })

    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
        new bootstrap.Tooltip(el, { container: 'body' });
    });

    const links = document.querySelectorAll(".navbar .nav-link.anchor");
    const bsOffcanvas = new bootstrap.Offcanvas('.offcanvas');
    links.forEach(link => {
        link.addEventListener("click", e => {
            e.preventDefault();
            let href = e.target.href;
            href = href.substr(href.indexOf('#'))
            // console.log(href);
            if (!isMobile()) {
                smoother.scrollTo(href, true);
            } else {
                gsap.to(window, { scrollTo: href });
            }

            // document.querySelector(".offcanvas").classList.remove("show");
            bsOffcanvas.hide();
            // or you could animate the scrollTop:
            // gsap.to(smoother, {
            //  scrollTop: smoother.offset(href, "center center"),
            //  duration: 1
            // });
            return false;
        });
    })


    let iSwiper, tSwiper;
    if (isMobile()) {

        initWhereWeWorkMobileMap();
        let aHeadings = document.querySelectorAll(".About h2");
        gsap.from(aHeadings, {
            y: 20,
            opacity: 0,
            stagger: 0.5,
            // filter: "blur(20px)",
            scrollTrigger: {
                trigger: aHeadings,
                start: 'top bottom-=100',
                // markers: true,
            }
        });

        let cHeadings = document.querySelectorAll(".Challenges h2");
        gsap.from(cHeadings, {
            y: 20,
            opacity: 0,
            stagger: 0.5,
            // filter: "blur(20px)",
            scrollTrigger: {
                trigger: cHeadings,
                start: 'top bottom-=100',
                // markers: true,
            }
        });

        let tHeadings = document.querySelectorAll(".Toolbox h2");
        gsap.from(tHeadings, {
            y: 20,
            opacity: 0,
            stagger: 0.5,
            // filter: "blur(20px)",
            scrollTrigger: {
                trigger: ".Toolbox",
                start: 'top bottom-=100',
                // markers: true,
            }
        });
    
    
        let toolTexts = document.querySelectorAll(".Toolbox .sub-text");
        // aboutTexts.forEach(txt=>{
        gsap.from(toolTexts, {
            y: 20,
            opacity: 0,
            stagger: 0.5,
            delay: 0.5,
            scrollTrigger: {
                trigger: ".Toolbox",
                start: 'top bottom-=100',
                // markers: true,
            }
        });
        // });

        let accHeadings = document.querySelectorAll(".Accordion .acc-title");
        gsap.from(accHeadings, {
            y: 20,
            opacity: 0,
            stagger: 0.5,
            // filter: "blur(20px)",
            scrollTrigger: {
                trigger: ".Accordion",
                start: 'top bottom-=100',
                // markers: true,
            }
        });

        let pHeadings = document.querySelectorAll(".Process h2");
        gsap.from(pHeadings, {
            y: 20,
            opacity: 0,
            stagger: 0.5,
            // filter: "blur(20px)",
            scrollTrigger: {
                trigger: ".Process",
                start: 'top bottom-=100',
                // markers: true,
            }
        });


        let processTexts = document.querySelectorAll(".Process .sub-text");
        // aboutTexts.forEach(txt=>{
        gsap.from(processTexts, {
            y: 20,
            opacity: 0,
            stagger: 0.5,
            delay: 0.5,
            scrollTrigger: {
                trigger: ".Process",
                start: 'top bottom-=100',
                // markers: true,
            }
        });
        // });
        
        let wwwHeadings = document.querySelectorAll(".WhereWeWork h2");
        gsap.from(wwwHeadings, {
            y: 20,
            opacity: 0,
            stagger: 0.5,
            // filter: "blur(20px)",
            scrollTrigger: {
                trigger: ".WhereWeWork",
                start: 'top bottom-=100',
                // markers: true,
            }
        });
        
        let wwwParag = document.querySelectorAll(".WhereWeWork p");
        gsap.from(wwwParag, {
            y: 20,
            opacity: 0,
            stagger: 0.5,
            // filter: "blur(20px)",
            scrollTrigger: {
                trigger: ".WhereWeWork",
                start: 'top bottom-=100',
                // markers: true,
            }
        });

        let wwwPills = document.querySelectorAll(".WhereWeWork .map-mobile-country-btn");
        gsap.from(wwwPills, {
            // y: 20,
            opacity: 0,
            stagger: 0.02,
            // filter: "blur(20px)",
            scrollTrigger: {
                trigger: ".map-mobile-nav",
                start: 'top bottom-=100',
                // markers: true,
            }
        });
        tSwiper = new Swiper('.TextSwiper', {
            modules: [Thumbs, Controller, Autoplay, Navigation],
            slidesPerView: 1,
            spaceBetween: 20,
            // watchSlidesProgress: true,
            slideThumbActiveClass: 'active',
            // loop: true,
            grabCursor: true,
            dragable: true,
            noSwiping: true,
            noSwipingSelector: 'a, .swiper-no-swiping',
            preventClicks: false,
            preventClicksPropagation: false,
            autoHeight: true,
            navigation: {
                nextEl: ".myswiper-button-next",
                prevEl: ".myswiper-button-prev",
            },
        })

    } else {

        const easing = "none";
        const dur = 5;
        const heroMorphTweens = [
            gsap.to("#c1", { duration: dur, morphSVG: "#c2", repeat: -1, yoyo: true, repeatDelay: 0.0, ease: easing, paused: true }),
            gsap.to("#d1", { duration: dur, morphSVG: "#d2", repeat: -1, yoyo: true, repeatDelay: 0.0, ease: easing, paused: true }),
            gsap.to("#e1a", { duration: dur, morphSVG: "#e2a", repeat: -1, yoyo: true, repeatDelay: 0.0, ease: easing, paused: true }),
            gsap.to("#e1b", { duration: dur, morphSVG: "#e2b", repeat: -1, yoyo: true, repeatDelay: 0.0, ease: easing, paused: true }),
            gsap.to("#f1a", { duration: dur, morphSVG: "#f2a", repeat: -1, yoyo: true, repeatDelay: 0.0, ease: easing, paused: true }),
            gsap.to("#f1b", { duration: dur, morphSVG: "#f2b", repeat: -1, yoyo: true, repeatDelay: 0.0, ease: easing, paused: true }),
            gsap.to("#g1a", { duration: dur, morphSVG: "#g2a", repeat: -1, yoyo: true, repeatDelay: 0.0, ease: easing, paused: true }),
            gsap.to("#g1b", { duration: dur, morphSVG: "#g2b", repeat: -1, yoyo: true, repeatDelay: 0.0, ease: easing, paused: true }),
            gsap.to("#h1a", { duration: dur, morphSVG: "#h2a", repeat: -1, yoyo: true, repeatDelay: 0.0, ease: easing, paused: true }),
            gsap.to("#h1b", { duration: dur, morphSVG: "#h2b", repeat: -1, yoyo: true, repeatDelay: 0.0, ease: easing, paused: true }),
        ];
        const toggleHeroMorphs = (shouldPlay) => {
            heroMorphTweens.forEach((tween) => {
                if (shouldPlay) {
                    tween.play();
                    return;
                }
    
                tween.pause();
            });
        };
        ScrollTrigger.create({
            trigger: ".Hero",
            start: "top bottom",
            end: "bottom top",
            onToggle: (self) => toggleHeroMorphs(self.isActive),
        });

        const heroCircle = document.querySelector(".hero-circle");
        gsap.to(heroCircle, {
            scale: 1.5,
            scrollTrigger: {
                trigger: ".Hero",
                start: "top top",
                scrub: 1.5,
                // markers: true,
            }
        })

        let aHeadings = document.querySelectorAll(".About h2");
        gsap.from(aHeadings, {
            x: -100,
            opacity: 0,
            stagger: 0.5,
            // filter: "blur(20px)",
            scrollTrigger: {
                trigger: aHeadings,
                start: 'top bottom-=200',
                // markers: true,
            }
        });

        let cHeadings = document.querySelectorAll(".Challenges h2");
        gsap.from(cHeadings, {
            x: -100,
            opacity: 0,
            stagger: 0.5,
            // filter: "blur(20px)",
            scrollTrigger: {
                trigger: cHeadings,
                start: 'top bottom-=300',
                // markers: true,
            }
        });

        let tHeadings = document.querySelectorAll(".Toolbox h2");
        gsap.from(tHeadings, {
            x: -100,
            opacity: 0,
            stagger: 0.5,
            // filter: "blur(20px)",
            scrollTrigger: {
                trigger: ".Toolbox",
                start: 'top bottom-=200',
                // markers: true,
            }
        });
    
    
        let toolTexts = document.querySelectorAll(".Toolbox .sub-text");
        // aboutTexts.forEach(txt=>{
        gsap.from(toolTexts, {
            x: -200,
            opacity: 0,
            stagger: 0.5,
            delay: 0.5,
            scrollTrigger: {
                trigger: ".Toolbox",
                start: 'top bottom-=300',
                // markers: true,
            }
        });
        // });

        let accHeadings = document.querySelectorAll(".Accordion .acc-title");
        gsap.from(accHeadings, {
            x: -100,
            opacity: 0,
            stagger: 0.5,
            // filter: "blur(20px)",
            scrollTrigger: {
                trigger: ".Accordion",
                start: 'top bottom-=200',
                // markers: true,
            }
        });

        let pHeadings = document.querySelectorAll(".Process h2");
        gsap.from(pHeadings, {
            x: -100,
            opacity: 0,
            stagger: 0.5,
            // filter: "blur(20px)",
            scrollTrigger: {
                trigger: ".Process",
                start: 'top bottom-=200',
                // markers: true,
            }
        });


        let processTexts = document.querySelectorAll(".Process .sub-text");
        // aboutTexts.forEach(txt=>{
        gsap.from(processTexts, {
            x: -200,
            opacity: 0,
            stagger: 0.5,
            delay: 0.5,
            scrollTrigger: {
                trigger: ".Process",
                start: 'top bottom-=300',
                // markers: true,
            }
        });
        // });

        let wwwHeadings = document.querySelectorAll(".WhereWeWork h2");
        gsap.from(wwwHeadings, {
            x: -100,
            opacity: 0,
            stagger: 0.5,
            // filter: "blur(20px)",
            scrollTrigger: {
                trigger: ".WhereWeWork",
                start: 'top bottom-=200',
                // markers: true,
            }
        });
        
        let wwwParag = document.querySelectorAll(".WhereWeWork p");
        gsap.from(wwwParag, {
            x: -200,
            opacity: 0,
            stagger: 0.5,
            // filter: "blur(20px)",
            scrollTrigger: {
                trigger: ".WhereWeWork",
                start: 'top bottom-=300',
                // markers: true,
            }
        });
    

        iSwiper = new Swiper('.ImageSwiper', {
            modules: [Thumbs, Controller, Autoplay, EffectCards,Navigation],
            slidesPerView: 1,
            watchSlidesProgress: true,
            slideThumbActiveClass: 'active',
            // speed: 600,
            effect: "cards",
            cardsEffect: {
                slideShadows: false,
            },
            navigation: {
                nextEl: ".myswiper-button-next",
                prevEl: ".myswiper-button-prev",
            },
        })

        tSwiper = new Swiper('.TextSwiper', {
            modules: [Thumbs, Controller, Autoplay, Navigation],
            slidesPerView: 1,
            watchSlidesProgress: true,
            slideThumbActiveClass: 'active',
            // loop: true,
            grabCursor: true,
            dragable: true,
            speed: 600,
            // breakpoints: {
            // },
            // autoplay: true,
            thumbs: {
                swiper: iSwiper,
            },
            navigation: {
                nextEl: ".myswiper-button-next",
                prevEl: ".myswiper-button-prev",
            },
        })

    }

    const toolSwiper = new Swiper('.magnetic-cards', {
        modules: [EffectCoverflow, Controller, Autoplay, Navigation, Pagination],
        effect: "coverflow",
        grabCursor: false,
        centeredSlides: true,
        slidesPerView: "auto",
        speed: 1000,
        noSwiping: true,
        noSwipingSelector: 'a, .swiper-no-swiping',
        preventClicks: false,
        preventClicksPropagation: false,
        // pin: true,
        // mousewheel: {
        //     enabled: true,
        //     releaseOnEdges: true,
        //     sensitivity: 3,
        //     thresholdDelta: 1,
        //     thresholdTime: 1000,
        // },
        autoplay: {
            delay: 1500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        // loop: true,
        coverflowEffect: {
            rotate: 40,
            stretch: -20,
            scale: 0.9,
            depth: 100,
            modifier: 1,
            slideShadows: false,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            dynamicBullets: true,
        },
    })


    const toolSwiper2 = new Swiper('.magnetic-cards2', {
        modules: [EffectCoverflow, Controller, Autoplay, Navigation, Pagination],
        effect: "coverflow",
        grabCursor: false,
        centeredSlides: true,
        slidesPerView: "auto",
        speed: 1000,
        noSwiping: true,
        noSwipingSelector: 'a, .swiper-no-swiping',
        preventClicks: false,
        preventClicksPropagation: false,
        // pin: true,
        // mousewheel: {
        //     enabled: true,
        //     releaseOnEdges: true,
        //     sensitivity: 3,
        //     thresholdDelta: 1,
        //     thresholdTime: 1000,
        // },
        autoplay: {
            delay: 1500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        // loop: true,
        coverflowEffect: {
            rotate: 40,
            stretch: -20,
            scale: 0.9,
            depth: 100,
            modifier: 1,
            slideShadows: false,
        },
        navigation: {
            nextEl: ".swiper-button-next2",
            prevEl: ".swiper-button-prev2",
        },
        pagination: {
            el: ".swiper-pagination2",
            dynamicBullets: true,
        },
    })


    const toolSwiper3 = new Swiper('.magnetic-cards3', {
        modules: [EffectCoverflow, Controller, Autoplay, Navigation, Pagination],
        effect: "coverflow",
        grabCursor: false,
        centeredSlides: true,
        slidesPerView: "auto",
        speed: 1000,
        noSwiping: true,
        noSwipingSelector: 'a, .swiper-no-swiping',
        preventClicks: false,
        preventClicksPropagation: false,
        // autoHeight: true,
        // pin: true,
        // mousewheel: {
        //     enabled: true,
        //     releaseOnEdges: true,
        //     sensitivity: 3,
        //     thresholdDelta: 1,
        //     thresholdTime: 1000,
        // },
        // autoplay: {
        //     delay: 1500,
        //     disableOnInteraction: false,
        //     pauseOnMouseEnter: true,
        // },
        // loop: true,
        coverflowEffect: {
            rotate: 40,
            stretch: -20,
            scale: 0.9,
            depth: 100,
            modifier: 1,
            slideShadows: false,
        },
        navigation: {
            nextEl: ".swiper-button-next3",
            prevEl: ".swiper-button-prev3",
        },
        pagination: {
            el: ".swiper-pagination3",
            dynamicBullets: true,
        },
    })

    let isToolboxVisible = false;
    const isPolicyTabActive = () => {
        const policyPane = document.querySelector('#pills-policy');
        return !!(policyPane && policyPane.classList.contains('active') && policyPane.classList.contains('show'));
    };
    const syncToolSwiper3Autoplay = () => {
        if (isToolboxVisible && isPolicyTabActive()) {
            toolSwiper3.autoplay.start();
            return;
        }

        toolSwiper3.autoplay.stop();
    };

    toolSwiper3.slideTo(0, 0);
    toolSwiper3.autoplay.stop();

    const toolboxCardLinks = document.querySelectorAll('.Toolbox .single-card a');
    toolboxCardLinks.forEach((link) => {
        link.classList.add('swiper-no-swiping');

        ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach((eventName) => {
            link.addEventListener(eventName, (event) => {
                event.stopPropagation();
            });
        });
    });

    const tabsEl = document.querySelectorAll('button[data-bs-toggle="pill"]')
    tabsEl.forEach(tab => {
        tab.addEventListener('shown.bs.tab', event => {
            console.log('update swiper')
            // event.target // newly activated tab
            // event.relatedTarget // previous active tab
            setTimeout(() => {
                toolSwiper.slideTo(0, 0);
                toolSwiper.update();
                toolSwiper2.slideTo(0, 0);
                toolSwiper2.update();
                toolSwiper3.slideTo(1, 0);
                toolSwiper3.update();
                syncToolSwiper3Autoplay();
            }, 50);
        })
    })

    ScrollTrigger.create({
        trigger: ".Toolbox",
        start: "top bottom",
        end: "bottom top",
        onToggle: (self) => {
            isToolboxVisible = self.isActive;
            syncToolSwiper3Autoplay();
        }
    })

    const mobileChallengeBreakpoint = window.matchMedia('(max-width: 767.98px)');
    const challengeCards = document.querySelectorAll('.Challenges .challenge[data-mobile-modal-target]');
    const syncChallengeCardAccessibility = () => {
        challengeCards.forEach((card) => {
            if (mobileChallengeBreakpoint.matches) {
                card.setAttribute('role', 'button');
                card.setAttribute('tabindex', '0');
                return;
            }

            card.removeAttribute('role');
            card.removeAttribute('tabindex');
        });
    };

    const openChallengeCardModal = (card) => {
        if (!mobileChallengeBreakpoint.matches) {
            return;
        }

        const modalSelector = card.dataset.mobileModalTarget;
        const modalEl = modalSelector ? document.querySelector(modalSelector) : null;

        if (!modalEl) {
            return;
        }

        bootstrap.Modal.getOrCreateInstance(modalEl).show();
    };

    challengeCards.forEach((card) => {
        card.addEventListener('click', (event) => {
            if (!mobileChallengeBreakpoint.matches) {
                return;
            }

            if (event.target.closest('[data-bs-toggle="modal"], a, button')) {
                return;
            }

            openChallengeCardModal(card);
        });

        card.addEventListener('keydown', (event) => {
            if (!mobileChallengeBreakpoint.matches) {
                return;
            }

            if (event.key !== 'Enter' && event.key !== ' ') {
                return;
            }

            event.preventDefault();
            openChallengeCardModal(card);
        });
    });

    syncChallengeCardAccessibility();
    mobileChallengeBreakpoint.addEventListener('change', syncChallengeCardAccessibility);

    // Recreate the journey accordion without Bootstrap's collapse plugin.
    const accordionEls = document.querySelectorAll('[data-accordion]');
    const accordionReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const accordionAnimationDuration = 800;

    const clearAccordionTransition = (panel) => {
        if (panel._accordionTransitionHandler) {
            panel.removeEventListener('transitionend', panel._accordionTransitionHandler);
            delete panel._accordionTransitionHandler;
        }

        if (panel._accordionTransitionTimer) {
            window.clearTimeout(panel._accordionTransitionTimer);
            delete panel._accordionTransitionTimer;
        }
    };

    const finishAccordionState = (panel, isOpen) => {
        clearAccordionTransition(panel);
        panel.classList.remove('collapsing');
        panel.classList.add('collapse');
        panel.classList.toggle('show', isOpen);
        // panel.style.height = '';
        panel.style.overflow = '';
        delete panel.dataset.transitioning;
    };

    const setAccordionState = (button, panel, isOpen) => {
        button.classList.toggle('collapsed', !isOpen);
        button.setAttribute('aria-expanded', `${isOpen}`);
        panel.setAttribute('aria-hidden', `${!isOpen}`);

        if (accordionReducedMotion) {
            finishAccordionState(panel, isOpen);
            return;
        }

        clearAccordionTransition(panel);
        panel.dataset.transitioning = 'true';
        panel.classList.remove('collapse', 'show');
        panel.classList.add('collapsing');
        panel.style.overflow = 'hidden';

        if (isOpen) {
            panel.style.height = '0px';
            // panel.offsetHeight;
            requestAnimationFrame(() => {
                panel.style.height = `${panel.scrollHeight}px`;
            });
        } else {
            panel.style.height = `${panel.scrollHeight}px`;
            // panel.offsetHeight;
            requestAnimationFrame(() => {
                panel.style.height = '0px';
            });
        }

        const handleTransitionEnd = (event) => {
            if (event.target !== panel || event.propertyName !== 'height') {
                return;
            }

            finishAccordionState(panel, isOpen);
        };

        panel._accordionTransitionHandler = handleTransitionEnd;
        panel.addEventListener('transitionend', handleTransitionEnd);
        panel._accordionTransitionTimer = window.setTimeout(() => {
            finishAccordionState(panel, isOpen);
        }, accordionAnimationDuration);
    };

    accordionEls.forEach((accordion) => {
        const buttons = accordion.querySelectorAll('[data-accordion-trigger]');

        buttons.forEach((button) => {
            const panelId = button.getAttribute('aria-controls');
            const panel = panelId ? accordion.querySelector(`#${panelId}`) : null;

            if (!panel) {
                return;
            }

            const isOpen = button.getAttribute('aria-expanded') === 'true';
            button.classList.toggle('collapsed', !isOpen);
            panel.classList.add('collapse');
            panel.classList.toggle('show', isOpen);
            panel.setAttribute('aria-hidden', `${!isOpen}`);

            button.addEventListener('click', (event) => {
                event.preventDefault();

                if (panel.dataset.transitioning === 'true') {
                    return;
                }

                const isCurrentlyOpen = button.getAttribute('aria-expanded') === 'true';

                buttons.forEach((otherButton) => {
                    const otherPanelId = otherButton.getAttribute('aria-controls');
                    const otherPanel = otherPanelId ? accordion.querySelector(`#${otherPanelId}`) : null;

                    if (!otherPanel || otherButton === button) {
                        return;
                    }

                    if (otherButton.getAttribute('aria-expanded') === 'true') {
                        setAccordionState(otherButton, otherPanel, false);
                    }
                });

                setAccordionState(button, panel, !isCurrentlyOpen);
            });
        });
    })

    // const strength_li = 50
    // const strength_a = 100
    // const magnetsli = document.querySelectorAll('.magnetic-cards .single-card');
    // const mag = document.querySelector(".magnetic-cards");
    // const bb = mag.getBoundingClientRect();
    // // const mlen = magnetsli.length;
    // function moveMagnets(event) {
    //     magnetsli.forEach((mli, idx) => {
    //         if (event.target != mli) {
    //             const mmbb = mli.getBoundingClientRect()
    //             gsap.to(mli, {
    //                 duration: 1,
    //                 x: (((event.clientX - mmbb.left) / bb.width) - 0.1) * strength_li * -1,
    //                 y: (((event.clientY - mmbb.top) / bb.height) - 0.1) * strength_li * -1,
    //                 ease: "power4.out"
    //             })
    //         } else {
    //             const mmbb = mli.getBoundingClientRect()
    //             gsap.to(mli, {
    //                 duration: 1,
    //                 x: (((event.clientX - mmbb.left) / mli.offsetWidth) - 0.5) * strength_a,
    //                 y: (((event.clientY - mmbb.top) / mli.offsetHeight) - 0.5) * strength_a,
    //                 ease: "power4.out"
    //             })
    //         }
    //     });
    // }

    // mag.addEventListener("mousemove", moveMagnets);
    // mag.addEventListener("mouseout", function (event) {
    //     magnetsli.forEach(mm => {
    //         gsap.to(mm, { duration: 1, x: 0, y: 0, ease: "power4.out" })
    //     })
    // });

    var heroTl = gsap.timeline();
    var split = new SplitText(".splitText", { type: "words, chars", position: "absolute" });
    heroTl.from(split.chars, {
        duration: 1,
        x: 200,
        autoAlpha: 0,
        ease: "power3",
        stagger: 0.1,
        filter: "blur(20px)",
    });
    var split = new SplitText(".splitSubText", { type: "words, chars", position: "absolute" });
    heroTl.from(split.words, {
        duration: 1,
        x: 200,
        autoAlpha: 0,
        ease: "power3",
        stagger: 0.1,
        filter: "blur(20px)",
    }, "<+1.1");

    let aboutTexts = document.querySelectorAll(".About .text-animation");
    // aboutTexts.forEach(txt=>{
    gsap.from(aboutTexts, {
        y: isMobile() ? 20 : 100,
        opacity: 0,
        stagger: 0.5,
        scrollTrigger: {
            trigger: ".About",
            start: isMobile() ? 'top+=100 bottom-=100' : 'top+=200 bottom-=200',
            // markers: true,
        }
    });
    // });

    let aboutImage = document.querySelectorAll(".About .img-wrapper");
    gsap.from(aboutImage, {
        y: isMobile() ? 20 : 100,
        opacity: 0,
        scrollTrigger: {
            trigger: aboutImage,
            start: isMobile() ? 'top bottom-=100' : 'top bottom-=300',
            // markers: true,
        }
    });

    let masktl = gsap.timeline({
        paused: true,
        repeat: -1,
        yoyo: true,
    })
    masktl.to("#original", {
        duration: 8,
        morphSVG: {
            shape: "#morph1",
            map: "position",
        },
        ease: "none"

    })
    masktl.to("#original", {
        duration: 8,
        morphSVG: {
            shape: "#morph2",
            map: "position",
        },
        ease: "none"

    })
    ScrollTrigger.create({
        trigger: ".About",
        start: "top bottom",
        end: "bottom top",
        onToggle: (self) => {
            if (self.isActive) {
                masktl.play();
                return;
            }

            masktl.pause();
        }
    })

    let aboutCards = document.querySelectorAll(".About .about-card");
    // aboutCards.forEach(card=>{
    gsap.from(aboutCards, {
        y: isMobile() ? 20 : 100,
        opacity: 0,
        stagger: 0.5,
        delay: 0.7,
        scrollTrigger: {
            trigger: ".About .card-wrapper",
            start: isMobile() ? 'top bottom-=100' : 'top bottom-=400',
            // markers: true,
        }
    });
    // });

    let aboutFormsF = document.querySelectorAll(".About .bg-forms.first");
    gsap.to(aboutFormsF, {
        y: 50,
        duration: 0.5,
        scrollTrigger: {
            trigger: ".About",
            toggleActions: "play pause reverse restart",
            scrub: 1,

        }
    })


    let aboutFormsS = document.querySelectorAll(".About .bg-forms.second");
    gsap.to(aboutFormsS, {
        y: 200,
        duration: 0.3,
        scrollTrigger: {
            trigger: ".About",
            toggleActions: "play pause reverse restart",
            scrub: 1,

        }
    })

    let aboutFormsT = document.querySelectorAll(".About .bg-forms.third");
    gsap.from(aboutFormsT, {
        y: -150,
        duration: 0.5,
        scrollTrigger: {
            trigger: ".About",
            toggleActions: "play pause reverse restart",
            scrub: 1,

        }
    })


    let challTextsF = document.querySelectorAll(".Challenges .first .h3");
    // aboutTexts.forEach(txt=>{
    gsap.from(challTextsF, {
        y: isMobile() ? 20 : 100,
        opacity: 0,
        stagger: 0.5,
        delay: isMobile() ? 0.7 : 0,
        scrollTrigger: {
            trigger: challTextsF,
            start: 'top bottom-=100',
            // markers: true,
        }
    });
    // });



    let challCardsF = document.querySelectorAll(".Challenges .first .challenge");
    // aboutTexts.forEach(txt=>{
    gsap.from(challCardsF, {
        y: isMobile() ? 20 : 100,
        opacity: 0,
        stagger: 0.5,
        delay: isMobile() ? 0.6 : 0,
        scrollTrigger: {
            trigger: challCardsF,
            start: isMobile() ? 'top bottom-=100' : 'top bottom-=150',
            // markers: true,
        }
    });
    // });


    let challTextsS = document.querySelectorAll(".Challenges .second .h3");
    // aboutTexts.forEach(txt=>{
    gsap.from(challTextsS, {
        y: isMobile() ? 20 : 100,
        opacity: 0,
        stagger: 0.5,
        scrollTrigger: {
            trigger: challTextsS,
            start: isMobile() ? 'top bottom-=100' : 'top bottom-=200',
            // markers: true,
        }
    });
    // });

    let challCardsS = document.querySelectorAll(".Challenges .second .challenge");
    // aboutTexts.forEach(txt=>{
    gsap.from(challCardsS, {
        y: isMobile() ? 20 : 100,
        opacity: 0,
        stagger: 0.5,
        // delay: 0.7,
        scrollTrigger: {
            trigger: challCardsS,
            start: isMobile() ? 'top bottom-=100' : 'top bottom-=200',
            // markers: true,
        }
    });
    // });


    let toolForms = document.querySelectorAll(".Toolbox .bg-forms");
    gsap.from(toolForms, {
        y: -100,
        duration: 0.5,
        scrollTrigger: {
            trigger: ".Toolbox",
            toggleActions: "play pause reverse restart",
            scrub: 1,

        }
    })

    // const toolCardsCont = document.querySelectorAll(".Toolbox .tab-content");
    // // const toolCards = document.querySelectorAll(".card-wrapper .single-card");
    // const toolCards = gsap.utils.toArray(".card-wrapper .single-card").reverse();
    // // toolCards.forEach(card=>{
    //     gsap.set(toolCards, {
    //         y: "+=100",
    //         opacity: 0,
    //     })
    //     gsap.to(toolCards, {
    //         y: 0,
    //         opacity: 1,
    //         stagger: 0.5,
    //         // delay: 0.7,
    //         scrollTrigger: {
    //             trigger: toolCards,
    //             start: 'top-=200 center+=100',
    //             end: "+=2000",
    //             toggleActions: "play pause reverse restart",
    //             scrub: true,
    //             // markers: true,
    //             // pin: ".magnetic-cards",
    //             invalidateOnRefresh: true,
    //         }
    //     });
    // // });

    // ScrollTrigger.create({
    //     trigger: toolCardsCont,
    //     start: "top-=50 top",
    //     pin: true,
    //     // pinSpacing: false,
    //     // markers: true,
    //     id: 'pin',
    //     end: 'bottom+=500',
    //     invalidateOnRefresh: true,
    //     // pinSpacer: toolCardsCont,
    // });




    let processForms = document.querySelectorAll(".Process .bg-forms");
    gsap.from(processForms, {
        y: -80,
        duration: 0.5,
        scrollTrigger: {
            trigger: ".Process",
            toggleActions: "play pause reverse restart",
            scrub: 1,

        }
    })


    let nextAnm = document.querySelector(".Process .myswiper-button-next");
    nextAnm.addEventListener('click', () => {
        nextAnm.classList.remove('animation');
    })

    // cursor follower
    // Check if it's a touch device
    const isTouchDevice = 'ontouchstart' in window;
    const $el = document.querySelector('.cursor-follower');
    gsap.set($el, {scale: 1/6});
    const createCursorFollower = () => {

        gsap.set($el, { yPercent: -50, xPercent: -50 })

        const easing = "power4", dur = 0.7;
        const xTo = gsap.quickTo($el, "x", { duration: dur, ease: easing }),
            yTo = gsap.quickTo($el, "y", { duration: dur, ease: easing }),
            opTo = gsap.quickTo($el, "opacity", { duration: dur, ease: easing }),
            scxTo = gsap.quickTo($el, "scaleX", { duration: dur, ease: easing }),
            scyTo = gsap.quickTo($el, "scaleY", { duration: dur, ease: easing });
        // Each time the mouse coordinates are updated,
        // we need to pass the values to gsap in order
        // to animate the element
        window.addEventListener('mousemove', (e) => {
            const { currentTarget, target, clientX, clientY } = e;
            const hoveredElement = target instanceof Element ? target : null;
            const cursorTrigger = hoveredElement && hoveredElement.closest ? hoveredElement.closest('[data-cursor]') : false;
            const mapCountry = hoveredElement && hoveredElement.closest ? hoveredElement.closest('#Map [data-tooltip]') : false;
            const mapCountryData = mapCountry && mapCountry.id ? mapCountries[mapCountry.id] : false;
            const hasMapInfo = !!(mapCountryData && (
                mapCountryData.info ||
                (mapCountryData.cities && mapCountryData.cities.length)
            ));
            const hasMapTooltipText = !!(mapCountry && mapCountry.dataset.tooltip && mapCountry.dataset.tooltip.trim());
            const activeTarget = cursorTrigger || ((hasMapInfo || hasMapTooltipText) ? mapCountry : false);
            let hasText = cursorTrigger ? (cursorTrigger.dataset.cursor ? cursorTrigger.dataset.cursor : false) : false;
            let hasTooltip = activeTarget === mapCountry && mapCountry ? mapCountry.id : false;
            let cursorVariant = cursorTrigger ? (cursorTrigger.dataset.cursorVariant ? cursorTrigger.dataset.cursorVariant : false) : false;
            // let moreId = isTargetLinkOrBtn ? isTargetLinkOrBtn.dataset.moreid ? isTargetLinkOrBtn.dataset.moreid : false : false;
            // let hasTooltipMore = isTargetLinkOrBtn ? isTargetLinkOrBtn.dataset.tooltipmore ? isTargetLinkOrBtn.dataset.tooltipmore : false : false;
            $el.classList.remove("maptooltip", "process-cursor");
            if (activeTarget) {
                if (hasText) {
                    $el.innerHTML = hasText;
                    if (cursorVariant === "process") {
                        $el.classList.add("process-cursor");
                    }
                } else if (hasTooltip) {
                    $el.classList.add("maptooltip");
                    const country = mapCountryData || {};
                    $el.innerHTML = buildMapCountryTooltip(
                        mapCountry.id,
                        country,
                        hasMapTooltipText ? mapCountry.dataset.tooltip : ''
                    );
                } else {
                    $el.innerHTML = "";
                }
            }
            // $el.innerHTML = isTargetLinkOrBtn ? hasText ? isTargetLinkOrBtn.dataset.cursor : "" : "";
            // let hasImage = isTargetLinkOrBtn ? isTargetLinkOrBtn.dataset.image ? isTargetLinkOrBtn.dataset.image : false : false;
            // $el.style.backgroundImage = hasImage ? `url(${hasImage})` : "none";
            // if (isTargetLinkOrBtn && isTargetLinkOrBtn.classList.contains("uactive")) {
            //     $el.style.backgroundImage = "none";
            //     $el.style.backgroundColor = "black";
            //     hasImage = false;
            //     hasText = "close";
            //     $el.innerHTML = hasText;
            // } else {
            //     $el.style.backgroundColor = "rgba(201, 251, 178, 1)";
            // }
            // GSAP config
            xTo(clientX);
            yTo(clientY);
            opTo(activeTarget ? 1 : 0);
            scxTo(activeTarget ? (hasText || hasTooltip) ? 1 : 4 : 0);
            scyTo(activeTarget ? (hasText || hasTooltip) ? 1 : 4 : 0);
            // hasImage ? $el.classList.add("big") : $el.classList.remove("big");

        });

        // Hidding the cursor element when the mouse cursor
        // is moved out of the page
        document.addEventListener('mouseleave', (e) => {
            gsap.to($el, {
                duration: dur,
                opacity: 0,
            });
            $el.innerHTML = "";
        });
    };

    // Only invoke the function if isn't a touch device
    if (!isTouchDevice) {
        createCursorFollower();
    }




    // const svgMap = document.querySelector("#Map");
    // const bbMap = svgMap.getBoundingClientRect();
    // const mapActiveCountries = svgMap.querySelectorAll("path[id]");
    // mapActiveCountries.forEach(c => {
    //     c.addEventListener("mouseover", function(event){
    //         const bb = c.getBoundingClientRect();
    //         const tt = document.createElement("span");
    //         tt.setAttribute("class", "mytooltip map");
    //         tt.innerHTML = c.id + "<hr>" + c.dataset["tooltip"];
    //         tt.style.top = (bbMap.top + bb.top + bb.height/2 - tt.clientHeight/2) + "px"
    //         tt.style.left = (bb.left + bb.width/2 - tt.clientWidth/2) + "px"
    //         c.parentElement.parentElement.appendChild(tt);

    //     })
    //     c.addEventListener("mouseout", function(event){
    //         const tt = c.parentElement.parentElement.querySelector("span");
    //         if (tt) tt.remove();
    //     })
    // })


    let wwaHeadings = document.querySelectorAll(".WhoWeAre h2");
    gsap.from(wwaHeadings, {
        y: isMobile() ? 20 : 100,
        opacity: 0,
        stagger: 0.5,
        // filter: "blur(20px)",
        scrollTrigger: {
            trigger: ".WhoWeAre",
            start: isMobile() ? 'tpo bottom-=100' : 'center bottom-=200',
            // markers: true,
        }
    });

    let wwaSubtext = document.querySelectorAll(".WhoWeAre .subtext");
    gsap.from(wwaSubtext, {
        y: isMobile() ? 20 : 100,
        opacity: 0,
        stagger: 0.5,
        // filter: "blur(20px)",
        scrollTrigger: {
            trigger: ".WhoWeAre",
            start: isMobile() ? 'top bottom-=100' : 'top+=100 bottom-=200',
            // markers: true,
        }
    });


    gsap.utils.toArray(".forest").forEach(function (container) {
        let image = container.querySelector("img");

        gsap.fromTo(image, {
            scaleY: 1.3,
            transformOrigin: "50% 50%",
            yPercent: -10,
            ease: "none",
            scrollTrigger: {
                trigger: container,
                scrub: true,
                pin: false,
            },
        }, {
            transformOrigin: "50% 50%",
            scaleY: 1.3,
            yPercent: 20,
            ease: "none",
            scrollTrigger: {
                trigger: container,
                scrub: true,
                pin: false,
            },
        });
    });

    const cloud = document.querySelector(".cloud-wrapper");
    const cloud1Tl = gsap.timeline({ paused: true, repeat: -1 });
    cloud1Tl
        .fromTo(cloud, {
            left: -1 * document.querySelector('.cloud-wrapper').clientWidth,
        }, {
            duration: 30,
            left: window.outerWidth + document.querySelector('.cloud-wrapper').clientWidth,
            ease: 'none',
        })
    ScrollTrigger.create({
        trigger: ".WhoWeAre",
        start: "top bottom",
        end: "bottom top",
        onToggle: (self) => {
            if (self.isActive) {
                cloud1Tl.play();
                return;
            }

            cloud1Tl.pause();
        }
    })

    const countupEls = document.querySelectorAll('.number');
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: '.WhoWeAre',
            start: isMobile() ? 'top bottom-=100' : 'center-=20% center',
            // markers: true,
        }
    })
    countupEls.forEach(el => {
        tl.counter(el, {
            end: parseInt(el.dataset["value"]),
            duration: 0.8,
            ease: 'none',
        }, '<')
    })


    let btnCards = document.querySelectorAll(".ByTheNumbers .single");
    // aboutCards.forEach(card=>{
    gsap.from(btnCards, {
        y: isMobile() ? 20 : 100,
        opacity: 0,
        stagger: isMobile() ? 0.2 : 0.4,
        delay: 0.7,
        scrollTrigger: {
            trigger: ".ByTheNumbers",
            start: isMobile() ? 'top bottom-=100' : 'top+=150 bottom-=400',
            // markers: true,
        }
    });
    // });


    if (!isMobile()) {
        smoother = ScrollSmoother.create({
            smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
            effects: true, // looks for data-speed and data-lag attributes on elements
            smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
        });
        const hash = window.location.hash;
        if (hash) {
            setTimeout(() => {
                smoother.scrollTo(hash, true);
            }, 500);
        }
    } else {
        const hash = window.location.hash;
        if (hash) {
            gsap.to(window, { scrollTo: hash });
        }
    }

})

const mapCountries = {
    "USA": {
        "info": "<span>Forestry Contractors Field Testing</span>",
        "cities": [
            {
                "name": "Appalachian Mountains",
                "tooltip": "Smallholders Access Program Pilot Test (2019)",
            },
        ]
    },
    "Mexico": {
        "info": "<span>Continuous Improvement Procedure participatory workshops</span><span>Economic Viability Tool Implementation</span><span>Timber Training Program (2022)</span>",
        "cities": [
            {
                "name": "Oaxaca",
                "tooltip": "Good Wood Program from Precious Woods – Applying the Screening Tool",
            },
            {
                "name": "Yucatan",
                "tooltip": "First CIP certification worldwide (2023)",
            },
        ]
    },
    "Guatemala": {
        "info": "<span>Mesoamerica Smallholder Market Forum</span><span>Timber Training Program (2022)</span>",
    },
    "Honduras": {
        "info": "<span>Application of the Collective Impact Model</span><span>Timber Training Program (2022)</span>",
    },
    "Panama": {
        "info": "Continuous Improvement Procedure, participatory workshops and Economic Viability Tool Implementation",
    },
    "Colombia": {
        "info": "Continuous Improvement Procedure, participatory workshops",
    },
    "Peru": {
        "info": "<span>Continuous Improvement Procedure, participatory workshops</span><span>Economic Viability Tool Implementation</span>",
        "cities": [
            {
                "name": "Amazonas",
                "tooltip": "Good Wood Program from Precious Woods – Applying the Screening Tool",
            },
        ]
    },
    "Bolivia": {
        "info": "Continuous Improvement Procedure, participatory workshops",
    },
    "Brazil": {
        "info": "<span>Forest Management Groups Pilot Testing</span><span>Application of the Collective Impact Model</span><span>Good Wood Program from Precious Woods – Applying the Screening Tool</span><span>Timber Training Program & Volume Aggregator Tool (2023)</span><span>Economic Viability Tool Implementation (2025)</span>",
    },
    "Chile": {
        "info": "<span>Good Wood Program from Precious Woods – Applying the Screening Tool</span><span>Application of the Collective Impact Model (2024)</span><span>Community of Practice implementation (2024)</span>",
    },
    "Argentina": {
        "info": "Application of the Collective Impact Model (2024)",
    },
    "Kenya": {
        "info": "<span>Continuous Improvement Procedure Testing (2021)</span><span>Economic Viability Tool Implementation (2025)</span>",
    },
    "Cameroon": {
        "info": "<span>Continuous Improvement Procedure, participatory workshops</span><span>Economic Viability Tool Training</span>",
    },
    "Eswatini": {
        "info": "Continuous Improvement Procedure Training (2024)",
    },
    "Spain": {
        "info": "Forest Management Groups Pilot Testing",
    },
    "France": {
        "info": "Forest Management Groups Pilot Testing",
    },
    "Portugal": {
        "cities": [
            {
                "name": "Lisbon",
                "tooltip": "CEFCO project; Smallholder Fund; European Smallholder Network (2008)",
            },
        ]
    },
    "Germany": {
        "info": "Cross-Country Workshop (2025)",
    },
    "Latvia": {
        "info": "Capacity Building and training for Baltic countries",
    },
    "Finland": {
        "info": "<span>Forest Management Groups Certification Workshop</span><span>Forest Management Groups Pilot Testing</span><span>Forestry Contractors Field Testing</span>",
    },
    "Sweden": {
        "info": "<span>Forest Management Groups Pilot Testing</span><span>Forestry Contractors Field Testing</span>",
    },
    "China": {
        "info": "Chinese National Forest Stewardship Standard with 10% conservation area pilot testing",
    },
    "Australia": {
        "info": "Forest Management Groups pilot testing",
    },
    "United Kingdom": {
        "cities": [
            {
                "name": "Wales",
                "tooltip": "Community Forests in FM Groups – Implementation of FSC’s certification for ecosystem services",
            },
        ]
    },
}

function buildMapCountryTooltip(countryId, country = {}, fallbackTooltip = '') {
    let html = `<b id="mapMobilePopupTitle">${countryId}</b><hr>`;

    if (country.info) {
        html += country.info;
    } else if (fallbackTooltip) {
        html += `<span>${fallbackTooltip}</span>`;
    }

    if (country.cities && country.cities.length) {
        html += '<ul>';
        for (let x = 0; x < country.cities.length; x++) {
            html += `<li><b>${country.cities[x].name}</b> - ${country.cities[x].tooltip}</li>`;
        }
        html += '</ul>';
    }

    return html;
}

function initWhereWeWorkMobileMap() {
    const mobileMapBreakpoint = window.matchMedia('(max-width: 767.98px)');
    const mapMobileNav = document.querySelector('.WhereWeWork .map-mobile-nav');
    const mapMobileButtonsWrap = document.querySelector('.WhereWeWork .map-mobile-buttons');
    const mapMobilePopup = document.getElementById('mapMobilePopup');
    const mapMobilePopupContent = mapMobilePopup ? mapMobilePopup.querySelector('.map-mobile-popup__content') : null;
    const mapMobilePopupClose = mapMobilePopup ? mapMobilePopup.querySelector('.map-mobile-popup__close') : null;
    const mapMobilePopupBackdrop = document.querySelector('.WhereWeWork .map-mobile-popup__backdrop');

    if (!mapMobileNav || !mapMobileButtonsWrap || !mapMobilePopup || !mapMobilePopupContent || !mapMobilePopupBackdrop) {
        return;
    }

    let activeCountryButton = null;

    const closeMapMobilePopup = () => {
        mapMobilePopup.hidden = true;
        mapMobilePopupBackdrop.hidden = true;
        mapMobilePopupBackdrop.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('map-mobile-popup-open');

        if (activeCountryButton) {
            activeCountryButton.classList.remove('is-active');
            activeCountryButton.setAttribute('aria-expanded', 'false');
            activeCountryButton = null;
        }
    };

    const openMapMobilePopup = (countryId, button) => {
        const country = mapCountries[countryId] || {};
        const mapPath = document.querySelector(`#Map [data-tooltip][id="${countryId}"]`);
        const fallbackTooltip = mapPath && mapPath.dataset.tooltip ? mapPath.dataset.tooltip : '';

        if (activeCountryButton && activeCountryButton !== button) {
            activeCountryButton.classList.remove('is-active');
            activeCountryButton.setAttribute('aria-expanded', 'false');
        }

        mapMobilePopupContent.innerHTML = buildMapCountryTooltip(countryId, country, fallbackTooltip);
        mapMobilePopup.hidden = false;
        mapMobilePopupBackdrop.hidden = false;
        mapMobilePopupBackdrop.setAttribute('aria-hidden', 'false');
        document.body.classList.add('map-mobile-popup-open');

        button.classList.add('is-active');
        button.setAttribute('aria-expanded', 'true');
        activeCountryButton = button;
        mapMobilePopupClose.focus();
    };

    const syncMapMobileNav = () => {
        if (!mobileMapBreakpoint.matches) {
            closeMapMobilePopup();
        }
    };

    Object.keys(mapCountries)
        .sort((a, b) => a.localeCompare(b))
        .forEach((countryId) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'map-mobile-country-btn';
            button.textContent = countryId;
            button.setAttribute('aria-expanded', 'false');
            button.setAttribute('aria-controls', 'mapMobilePopup');
            button.addEventListener('click', () => {
                if (!mobileMapBreakpoint.matches) {
                    return;
                }

                if (activeCountryButton === button && !mapMobilePopup.hidden) {
                    closeMapMobilePopup();
                    return;
                }

                openMapMobilePopup(countryId, button);
            });
            mapMobileButtonsWrap.appendChild(button);
        });

    mapMobilePopupClose.addEventListener('click', closeMapMobilePopup);
    mapMobilePopupBackdrop.addEventListener('click', closeMapMobilePopup);

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !mapMobilePopup.hidden) {
            closeMapMobilePopup();
        }
    });

    if (typeof mobileMapBreakpoint.addEventListener === 'function') {
        mobileMapBreakpoint.addEventListener('change', syncMapMobileNav);
    } else if (typeof mobileMapBreakpoint.addListener === 'function') {
        mobileMapBreakpoint.addListener(syncMapMobileNav);
    }

    syncMapMobileNav();
}